const vwoSDK = require('vwo-node-sdk');

const vwoHelper = {
    getSettingsFile(accountId, sdkKey, config) {
    // Only for debugging and development
    // process.env['NODE_TLS_REJECT_UNAUTHORIZED'] = 0;

        return vwoSDK.getSettingsFile(accountId, sdkKey, config);
    },
    initVWOSdk(settingsFile) {
        const vwoClientInstance = vwoSDK.launch({
            // isDevelopmentMode: false,
            settingsFile
            //   logging
            // pollingInterval: 5000,
            // sdkKey: sdkKey
        });

        vwoHelper.vwoClientInstance = vwoClientInstance;
        return vwoClientInstance;
    }
};

module.exports = vwoHelper;
